import React from 'react';

// Global Components
// @ts-ignore
import DayOfWeekDate from 'components/DayOfWeekDate';
import MyTimesheetEntriesDayTotal from 'components/MyTimesheetEntriesDayTotal';
import QueryStringButton from 'components/QueryStringButton';

interface Props {
    dayOfWeek: number;
}

export class MyTimesheetEntriesDayButton extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { dayOfWeek } = this.props;
        return (
            <QueryStringButton
                params={{
                    dayOfWeek
                }}
                buttonProps={{
                    basic: true,
                    primary: true
                }}
            >
                <b style={{ display: 'block' }}>
                    <DayOfWeekDate dayOfWeek={dayOfWeek} format="dd" />
                </b>
                <small>
                    <MyTimesheetEntriesDayTotal dayOfWeek={dayOfWeek} />
                </small>
            </QueryStringButton>
        );
    }
}

export default MyTimesheetEntriesDayButton;
